import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Mis clientas preguntan quién hace mi contenido. Se ve premium.',
    author: 'Laura P.',
    location: 'Manicurista · Rosario',
    initial: 'L'
  }, {
    quote: 'Antes perdía el 60% de las consultas, ahora cierro casi todas.',
    author: 'Romina M.',
    location: 'Lashista · Buenos Aires',
    initial: 'R'
  }, {
    quote: 'Saber exactamente qué publicar cada día no tiene precio.',
    author: 'Julia M.',
    location: 'Estilista · Tucumán',
    initial: 'J'
  }, {
    quote: 'En 3 semanas pasé de 800 a 2.400 seguidores.',
    author: 'Valeria L.',
    location: 'Emprendedora digital · Mendoza',
    initial: 'V'
  }];
  const Stars = () => <div className="flex gap-1 md:gap-1.5 text-[#c9a961] mb-3 md:mb-6" data-id="element-383">
      {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" className="drop-shadow-[0_0_5px_rgba(201,169,97,0.3)] w-4 h-4 md:w-5 md:h-5" data-id="element-384" />)}
    </div>;
  return <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto bg-[#faf7f2]" data-id="element-385">
      <FadeIn data-id="element-386">
        <h2 className="text-2xl md:text-5xl font-black text-[#1a1611] text-center mb-6 md:mb-14 flex items-center justify-center gap-2 md:gap-4 px-2" data-id="element-387">
          <span className="text-[#b91c1c] drop-shadow-[0_0_15px_rgba(185,28,28,0.2)]" data-id="element-388">
            ❤️
          </span>{' '}
          LO QUE DICEN LAS QUE YA LO TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-8" data-id="element-389">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-390">
            <motion.div whileHover={{
          y: -5
        }} className="bg-white border border-[#e8dfd0] hover:border-[#c9a961]/50 rounded-2xl md:rounded-3xl p-5 md:p-8 h-full relative overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-391">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-[#f5f0e8] w-16 h-16 md:w-24 md:h-24 rotate-180 -z-0" data-id="element-392" />

              <div className="relative z-10 flex flex-col h-full" data-id="element-393">
                <Stars data-id="element-394" />
                <p className="text-base md:text-xl text-[#1a1611] mb-4 md:mb-8 italic leading-relaxed font-medium flex-grow" data-id="element-395">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 md:gap-4 mt-auto pt-4 md:pt-6 border-t border-[#e8dfd0]" data-id="element-396">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#c9a961] to-[#d4af37] rounded-full flex items-center justify-center text-[#0a0a0a] font-black text-base md:text-xl shadow-[0_5px_15px_rgba(201,169,97,0.3)]" data-id="element-397">
                    {t.initial}
                  </div>
                  <div data-id="element-398">
                    <p className="font-black text-[#1a1611] text-base md:text-lg" data-id="element-399">
                      {t.author}
                    </p>
                    <p className="text-xs md:text-sm text-[#6b5d4f] font-bold" data-id="element-400">
                      {t.location}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}